import { BoxesStackedIcon, FileCsvIcon } from '@revfluence/fresh-icons/regular/esm';
import React from 'react';

export const NonShopifyCollection = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full bg-grey-1 border border-grey-2 rounded-md p-16 space-y-3">
      <div className="w-20 h-20 text-grey-2">
        <BoxesStackedIcon fontSize={80} className="text-grey-2" />
      </div>
      <div>
        <h2 className="text-base font-medium text-grey-6 text-center">
          Start importing your products
        </h2>
        <p className="text-sm text-grey-5 font-normal text-center max-w-md m-0">
          Easily import products from shopify or csv library.
        </p>
      </div>
      <div className="bg-grey-0 border border-grey-2 rounded-xl py-4 px-6 max-w-sm w-full shadow-sm">
        <div className="flex flex-col items-center text-center">
          <div className="w-12 h-12 text-grey-6">
            <FileCsvIcon fontSize={32} className="text-grey-6" />
          </div>
          <h3 className="text-sm font-medium text-grey-6">
            Upload Collection via CSV
          </h3>
          <p className="text-xs text-grey-4 font-normal m-0">
            Create a new object to become more powerful.
          </p>
        </div>
      </div>
      <div>
        <a
          href="https://docs.aspirex.com/docs/products/importing-products"
          target="_blank"
          className="text-grey-6 hover:text-grey-5 underline text-sm transition-colors"
        >
          Learn more about importing products
        </a>
      </div>
    </div>
  );
};
